<template>
  <div>
    <div class="section" :class="{ active: isActive }">
      <h3 @click="makeActive" @keypress="makeActive" :class="{ active: isActive }" class="name" tabindex="0">
        {{ name }}
        <span class="plusMinus"> </span>
      </h3>
      <div class="checkboxContainer" :class="{ active: open }">
        <div class="list">
          <div class="filter" v-for="option in options" :key="option.id">
            <a
              :id="option.id"
              @click="emitChange(option)"
              @keypress="emitChange(option)"
              :class="{ active: isChecked(option.id) }"
              tabindex="0"
              >{{ option.title }}</a
            >
            <button
              class="reset"
              v-if="isChecked(option.id)"
              v-on:click="clearTag(option)"
            >
              Clear
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

import { ExtendedTaxonomyTag } from "../models/ExtendedTaxonomyTag";

export default Vue.extend({
  name: "FilterDropDown",
  props: {
    name: {
      type: String,
      required: true,
      default: ""
    },
    open: {
      type: Boolean
    },
    isActive: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array as () => ExtendedTaxonomyTag[],
      required: true,
      default: () => []
    },
    active: {
      type: Array as () => ExtendedTaxonomyTag[],
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      selectedOption: 0 as number
    };
  },
  methods: {
    makeActive(): void {
      this.isActive = !this.isActive;
    },
    isChecked(id: string): boolean {
      return (
        this.$props.active
          .map(function(e: ExtendedTaxonomyTag) {
            return e.id;
          })
          .indexOf(id) > -1
      );
    },
    emitChange(value: ExtendedTaxonomyTag): void {
      this.$props.options.forEach((element: ExtendedTaxonomyTag) => {
        if (element.id == value.id) {
          this.$data.selectedOption = element;
        }
      });
      this.$emit("inputChange", this.$data.selectedOption);
      this.$data.selectedOption = 0;
    },
    clearTag: function(tag: ExtendedTaxonomyTag): void {
      this.$emit("clearTag", tag);
    }
  }
});
</script>
